const initialState = {
    isSmartSheetLoaded:false,
    loId:'',
    smartSheetData:{},
};

const smartSheetReducer =(state=initialState, action:any) =>{
switch (action.type) {
    case "SET_IS_SMARTSHEET_LOADED":
      return { ...state, isSmartSheetLoaded: action.payload };
    case "SET_SMARTSHEET_INFO":
      return { ...state,...action.payload };
    case "SET_INITIAL_STATE":
      return { ...initialState };
    case "LOGOUT":
      return { ...initialState };
    default:
      return state;
}
}

export default smartSheetReducer